"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const gotoURL = (x) => window.location.href = x; exports.gotoURL = gotoURL
